export interface UserFields {
  email: string;
  givenName: string;
  familyName: string;
}

// Deliberately simple - Cognito/the backend stays authoritative. This only catches obvious typos.
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Returns the first problem found, or null when the fields are acceptable. Shared by Create User
// and Edit User so the two forms can't drift apart.
export const validateUserFields = ({ email, givenName, familyName }: UserFields): string | null => {
  const trimmedEmail = email.trim();
  if (trimmedEmail.length < 11) return "Email must be at least 11 characters.";
  if (!EMAIL_PATTERN.test(trimmedEmail)) return "Enter a valid email address.";
  if (givenName.trim().length < 1) return "First name is required.";
  if (familyName.trim().length < 1) return "Last name is required.";
  return null;
};
